import { getBaseApiPath } from '@/app/common/api/config';

export type TokenRefreshLogPayload = {
  accessToken?: string | null;
  refreshToken?: string | null;
  failedApiUrl?: string;
  refreshStatusCode?: number;
  refreshResponseBody?: string | null;
  errorMessage?: string | null;
  reason: 'refresh_failed' | 'refresh_error';
};

export async function logTokenRefreshFailure(
  payload: TokenRefreshLogPayload
): Promise<void> {
  try {
    await fetch(`${getBaseApiPath()}/go_report/v1/auth/token-refresh-log`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        access_token: payload.accessToken ?? '',
        refresh_token: payload.refreshToken ?? '',
        failed_api_url: payload.failedApiUrl ?? '',
        refresh_status_code: payload.refreshStatusCode ?? null,
        refresh_response_body: payload.refreshResponseBody ?? null,
        error_message: payload.errorMessage ?? null,
        user_agent: navigator.userAgent,
        page_url: window.location.href,
        reason: payload.reason
      })
    });
  } catch {
    // Silently ignore logging failures so logout flow is not blocked.
  }
}
